export default __webpack_public_path__ + "static/media/fondo-individuales.21ff6206.png";